module.exports = __webpack_public_path__ + "img/sobres-paper-bombolla.d6c329fa.jpg";